












export default
  watch: {
    list: (e) ->
      @list = e
  }

  props: {
    list:
      type: [Array, null]
      default: () => null
    subTitle:
      type: String
      default: '代理店'
  }
